import Vue from 'vue';
import { TranslateResult } from 'vue-i18n';
import { MealOptions, MealValues } from '@/constants/mealOption';

Vue.mixin({
  methods: {
    getMealOptionScope(mealOption: Array<MealValues>): MealOptions {
      if (mealOption.length > 1) return MealOptions.breakfast_with_dinner;
      else if (mealOption.length) return MealOptions.with_breakfast;
      return MealOptions.no_meals;
    },
    getMealOptionValue(scope: MealOptions): Array<MealValues> {
      switch (scope) {
        case MealOptions.with_breakfast:
          return [MealValues.breakfast];
        case MealOptions.breakfast_with_dinner:
          return [MealValues.breakfast, MealValues.dinner];
        default:
          return [];
      }
    },
    getMealTranslation(mealOption: Array<MealValues> | MealOptions): TranslateResult {
      const scope: MealOptions = typeof mealOption === 'string' ? mealOption : this.getMealOptionScope(mealOption);
      return this.$t(`common.meal_options.${scope}`);
    },
  },
});
